module.exports = __webpack_public_path__ + "img/safari.769b9ab3.png";